import React, { useCallback, useContext } from 'react';
import { Form } from 'react-final-form';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { Button, FlexMiddle } from '@ubeya/shared-web/components';
import AddCreditCardFields from './AddCreditCardFields';

const Container = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 15px;

  > div:nth-child(1),
  > div:nth-child(4),
  > div:nth-child(5) {
    grid-column: span 2;
  }
`;

const Buttons = styled(FlexMiddle)`
  grid-column: span 2;
  margin: 0;
  width: 100%;

  > button {
    width: 100%;
  }

  > button:not(:first-child) {
    margin-right: 10px;
    width: 100%;
  }
`;

const AddCreditCard = ({ onClose, onConfirm }) => {
  const { t } = useContext(ConfigContext);

  const handleSubmit = useCallback(
    async (values) => {
      const { number: creditCardNumber, ...restValues } = values || {};

      await onConfirm({
        type: 'CREDIT_CARD',
        metadata: {
          ...restValues,
          number: creditCardNumber.replace(/\s/g, ''),
          type: 'VISA'
        }
      });
      onClose();
    },
    [onClose, onConfirm]
  );

  return (
    <Form
      onSubmit={handleSubmit}
      render={({ handleSubmit: onSubmit, submitting, valid }) => (
        <Container onSubmit={onSubmit}>
          <AddCreditCardFields />

          <Buttons>
            <Button primary isLoading={submitting} disabled={submitting || !valid}>
              {t('save')}
            </Button>
          </Buttons>
        </Container>
      )}
    />
  );
};

export default AddCreditCard;
